export default __webpack_public_path__ + "static/media/texture4.1334d1d3.png";